import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import {
    PaymentCondition,
    PaymentConditionFilters
} from '../../../../app/models/PaymentCondition';
import PaymentConditionSwitchChange from '../PaymentConditionSwitchChange';

interface Props {
    paymentConditions: PaymentCondition[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    filter: PaymentConditionFilters;
    setFilter: (filter: PaymentConditionFilters) => void;
    callbackSuccess: () => void;
}

const PaymentConditionDataTable = ({
    paymentConditions,
    totalRows,
    loading = false,
    edit,
    destroy,
    active,
    filter,
    setFilter,
    callbackSuccess
}: Props) => {
    const columns = [
        {
            name: 'ID',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            width: '80px',
            cell: (row: PaymentCondition) => <span>{row.id ?? '-'}</span>
        },
        {
            name: 'Nombre',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: PaymentCondition) => <span>{row.name}</span>
        },
        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            width: '100px',
            cell: (row: PaymentCondition) =>
                row.id ? (
                    <PaymentConditionSwitchChange
                        checkValue={row.is_active ?? true}
                        paymentConditionId={row.id}
                        callbackSuccess={callbackSuccess}
                    />
                ) : null
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            width: '150px',
            cell: (row: PaymentCondition) => (
                <div className="">
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">{/* Filtros pueden agregarse aquí si es necesario */}</div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={paymentConditions}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default PaymentConditionDataTable;
